import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        nav(`/${data.user.role}`, { replace: true, state: { user: data.user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return <div className="min-h-screen grid place-items-center mono">Signing you in…</div>;
}
